import React, { useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { Route, Switch } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import Modal from '../../../../components/Modal';
import { ModalContentSpacing } from '../../../../constants/ui/modal';
import { getPortalRootDOMElement } from '../../../../DOMElements';
import useRouter from '../../../../hooks/useRouter';
import { ZIndices } from '../../../../styled-components/dark/common';
import { RoutePatterns } from '../../../../types/routes';
import MissionDetailsContainer from '../MissionDetails/MissionDetailsContainer';
import MissionsContainer from '../Missions/MissionsContainer';
import MobileMissionDetailsModal from '../MobileMissionDetailsModal';

const sharedStyle = css`
  font-family: 'BettingArchivoNarrow';
  font-size: 90%;
  color: white;
`;

const StyledMissionDetailsContainer = styled(MissionDetailsContainer)`
  ${sharedStyle}
`;

const StyledMobileMissionDetailsModalContainer = styled(MobileMissionDetailsModal)`
  ${sharedStyle}
`;

type MissionDetailsHandlerProps = {
  missionId?: number;
};

const MobileMissionDetailsHandler = ({ missionId }: MissionDetailsHandlerProps) => {
  return <StyledMobileMissionDetailsModalContainer missionId={missionId ?? 0} isOpen={!!missionId} />;
};

const MissionsRouterSwitch = () => {
  const { history, location } = useRouter();
  const missionDetailsMatch = useMemo(() => location?.hash?.match(/^#mission-details-(\d+)$/), [location]);
  const missionId = useMemo(
    () => (missionDetailsMatch?.[1] ? parseInt(missionDetailsMatch?.[1], 10) : undefined),
    [missionDetailsMatch],
  );

  const onCloseDesktopModal = useCallback(() => {
    history.replace(location.pathname);
  }, [history, location]);

  return (
    <>
      <Switch>
        <Route path={RoutePatterns.EXTRAS} exact>
          <MissionsContainer />
        </Route>
      </Switch>
      {Target.__MOBILE__ ? <MobileMissionDetailsHandler missionId={missionId} /> : null}
      {!Target.__MOBILE__ && missionId
        ? createPortal(
            <Modal
              backgroundColor={'#000000'}
              contentSpacing={ModalContentSpacing.NONE}
              hasOverlay
              closeOnOutsideClick
              closeOnEsc
              onClose={onCloseDesktopModal}
              hasCloseButton
              disableScrollView
              contentScrollable
              noOverflowHidden
              hasBorderRadius
              forbidBackgroundScrolling
              zIndex={ZIndices.missionsDetailsModal}
            >
              <StyledMissionDetailsContainer missionId={missionId} />
            </Modal>,
            getPortalRootDOMElement(),
          )
        : null}
    </>
  );
};

export default MissionsRouterSwitch;
